module.exports = __webpack_public_path__ + "static/media/facesheet@2x + copy to chart@2x Mask.3caded18.png";